import { useCallback } from "react";
import { useSelector } from "react-redux";
import { getQueryData } from "src/helpers/helpers";
import useFetchAsync from "src/hooks/useFetchAsync";
import {
  deleteReq,
  patch,
  useGet,
  usePatch,
  usePost,
} from "src/http-clients/clients";
import { getActiveStoreId } from "src/redux/selectors/app";

export const useCreateService = () => {
  const activeStore = useSelector(getActiveStoreId);
  return usePost(`/users/stores/${activeStore}/services/create`);
};

export const useGetServices = ({
  length,
  page,
  search,
}: {
  length?: number;
  page?: number;
  search?: string;
}) => {
  const activeStore = useSelector(getActiveStoreId);
  let offset;
  if (page && length) {
    offset = page === 1 ? 0 : (page - 1) * length;
  }
  const queryData = getQueryData({ length, offset, search });
  const data = useGet(
    offset === undefined
      ? `/users/stores/${activeStore}/services/list`
      : `/users/stores/${activeStore}/services/list${queryData}`
  );
  return data;
};

export const useGetServiceData = (serviceId: number) => {
  const activeStore = useSelector(getActiveStoreId);
  return useGet(
    serviceId ? `/users/stores/${activeStore}/services/${serviceId}` : null
  );
};

export const useUpdateService = (serviceId: number) => {
  const activeStore = useSelector(getActiveStoreId);
  return usePatch(`/users/stores/${activeStore}/services/${serviceId}`);
};

export const useDeleteService = () => {
  const activeStore = useSelector(getActiveStoreId);
  const deleteData = useCallback(
    (serviceId: number) => {
      return deleteReq(`/users/stores/${activeStore}/services/${serviceId}`);
    },
    [activeStore]
  );
  return useFetchAsync(deleteData);
};

export const useUpdateServiceStatus = () => {
  const activeStore = useSelector(getActiveStoreId);
  const handleStatusChange = useCallback(
    (serviceId: number, status: boolean) => {
      return patch(
        `/users/stores/${activeStore}/services/${serviceId}/status`,
        {
          status,
        }
      );
    },
    [activeStore]
  );
  return useFetchAsync(handleStatusChange);
};
